import React from "react";
import PropTypes from "prop-types";

// components
import SideBarSection from "../SideBarSection";
import AddTag from "./AddTag";
import TagList from "./TagList";

// QueueContext
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout";

// helpers
import { getPendingAndApprovedTags } from "./helpers.js";

export const Tags = ({
    children,
    onTagAdd,
    onTagApprove,
    onTagRemove,
    isEditable
}) => {
    // state/context
    const { state, showTags } = useQueueContext();
    const { selectedUploads } = state;

    if (!showTags) return null;

    // Upload
    const { pendingTags, approvedTags } = getPendingAndApprovedTags(
        selectedUploads
    );

    return (
        <SideBarSection title="Tags">
            <AddTag onTagAdd={onTagAdd} />
            <TagList
                title="Pending"
                tags={pendingTags}
                onTagApprove={onTagApprove}
                onTagRemove={onTagRemove}
                isEditable={isEditable}
            />
            <TagList
                title="Approved"
                tags={approvedTags}
                onTagApprove={onTagApprove}
                onTagRemove={onTagRemove}
                isEditable={isEditable}
            />
            {children}
        </SideBarSection>
    );
};

export default Tags;

// prop-types
Tags.propTypes = {
    children: PropTypes.any,
    onTagAdd: PropTypes.func.isRequired,
    onTagApprove: PropTypes.func.isRequired,
    onTagRemove: PropTypes.func.isRequired,
    isEditable: PropTypes.bool
};
